__turbopack_context__.v({
  "iconMoon": "ThemeToggle-module-scss-module__kbHJTa__iconMoon",
  "iconMoonShow": "ThemeToggle-module-scss-module__kbHJTa__iconMoonShow",
  "iconSlot": "ThemeToggle-module-scss-module__kbHJTa__iconSlot",
  "iconSun": "ThemeToggle-module-scss-module__kbHJTa__iconSun",
  "iconSunShow": "ThemeToggle-module-scss-module__kbHJTa__iconSunShow",
  "iconSvg": "ThemeToggle-module-scss-module__kbHJTa__iconSvg",
  "root": "ThemeToggle-module-scss-module__kbHJTa__root",
  "rootMobileNavbar": "ThemeToggle-module-scss-module__kbHJTa__rootMobileNavbar",
  "thumb": "ThemeToggle-module-scss-module__kbHJTa__thumb",
  "thumbOnDark": "ThemeToggle-module-scss-module__kbHJTa__thumbOnDark",
  "thumbOnLight": "ThemeToggle-module-scss-module__kbHJTa__thumbOnLight",
  "track": "ThemeToggle-module-scss-module__kbHJTa__track",
  "trackDark": "ThemeToggle-module-scss-module__kbHJTa__trackDark",
  "trackLight": "ThemeToggle-module-scss-module__kbHJTa__trackLight",
});
